// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"539":"2f59bec3","864":"37ce1309"}[chunkId] + ".chunk.css";
};